/**
 * API configuration
 */
const baseUrl =
  process.env.NEXT_PUBLIC_API_URL ??
  process.env.EXPO_PUBLIC_API_URL ??
  'http://localhost:3000';

export const apiConfig = {
  /**
   * Base API URL
   * Override with environment variable NEXT_PUBLIC_API_URL or EXPO_PUBLIC_API_URL
   */
  baseUrl,

  /**
   * Request timeout in milliseconds
   */
  timeout: 30000,

  /**
   * Retry configuration
   */
  retry: {
    maxRetries: 3,
    retryDelay: 1000,
    retryCondition: (error: any) => {
      return error.response?.status >= 500 || !error.response;
    },
  },

  /**
   * Default headers
   */
  defaultHeaders: {
    Accept: 'application/json',
  },

  /**
   * Enable credentials (cookies)
   */
  withCredentials: true,
} as const;

/**
 * API versioning
 */
export const API_VERSION = 'v1';

/**
 * API rate limiting
 */
export const rateLimitConfig = {
  maxRequests: 100,
  perWindow: 60000, // 1 minute
} as const;
